import { formatPercentage } from '@witmetrics/utils/strings';
import type { SelectDropdownOption } from '@/components/inputs/SelectDropdown';
import { SCALES } from '../constants';

export const SCALE_OPTIONS: SelectDropdownOption<number>[] = SCALES.map(
  (scale) => ({ label: formatPercentage(scale, 0), value: scale })
).reverse();
